module.exports = __webpack_public_path__ + "images/homepage/stuff-move-in.svg";